import { Pipe, PipeTransform } from '@angular/core';
/**
 * Retourne l'information sur le code d'licence. Par défaut on retourne le code
 * @param licenceId
 * @param licenceCodeList
 */
@Pipe({
  name: 'getLicenceCode',
})
export class LicenceCodePipe implements PipeTransform {
  transform(licenceId: any, licenceCodeList: any, fieldToReturn: string = 'code'): string {
    // rechercher si la liste n'est pas vide
    if (licenceCodeList) {
      let name = licenceCodeList
        .filter((c: any) => c.licenceId == licenceId)
        .map((c: any) => {
          return c.licenceCode;
        });
      if (name && name.length > 0) {
        return name[0];
      }
    }
    // on retourne le licenceId si on ne trouve pas le nom (j'ai vu des licenceId == -1 dans la DB)
    return licenceId <= 0 ? '' : licenceId;
  }
}
